const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  hasPermission,
};